module.exports = __webpack_public_path__ + "static/media/086-options.b4eee4d1.svg";